import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { SampleRequestService } from "../../../Services/SampleRequest.Service";
import LoadingComponent from "../../../Components/LoadingComponent";

function SchedulePickupSampleRequestModal({ show, onConfirm, handleClose, type, duration , sample_ids, sample_count, volunteer_count, lab_id, div_type, confirmDelivery  }) {
    const [scheduledDate, setScheduledDate] = useState(null);
    const [startScheduledDate, setStartScheduledDate] = useState(null);
    const [scheduledTime, setScheduledTime] = useState([]);
    const [selectedTime, setSelectedTime] = useState(null);
    const [vacations, setVacations] = useState([]);
    const [labClosedDays, setLabClosedDays] = useState([]);
    const [errors, setErrors] = useState({});
    const isModal = div_type !== "as-div";
    const [loading, setLoading]= useState(false);

    const [questSlots, setQuestSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);

    useEffect(() => {
        if (show) {
            setLoading(true);
            const sampleIdsArray = Object.keys(sample_ids).filter(
                (key) => sample_ids[key] === true
            );

            const getPickupTimeSchedule = {
                lab_id,
                duration,
                sample_count,
                volunteer_count,
                sample_ids : sampleIdsArray
            };

            SampleRequestService.getPickupTimeSchedule(getPickupTimeSchedule)
            .then((data) => {
                setScheduledDate(data.start_date || null);
                setStartScheduledDate(data.start_date || null);
                // setScheduledTime(data.pickup_time?.map((time) => time.slice(0, 5)) || []); //commmented for new updates 
                setVacations(data.vacations || []);
                setLabClosedDays(data.lab_closed || []);

                // NEW: quest_slots mapping
                const slots = data.quest_slots
                ? Object.values(data.quest_slots).map(q => ({
                    displayTime: q.time,   // UI
                    slots: q.slots,        // backend
                    }))
                : [];

                setQuestSlots(slots);
                setLoading(false);
                })
                .catch((error) => {setLoading(false);console.error("Error fetching pickup time schedule:", error)});
        }
    }, [show, duration, sample_count, volunteer_count, lab_id]);

    const handleModalClose = () => {
        setScheduledDate(null);
        setStartScheduledDate(null);
        setScheduledTime([]);
        setSelectedTime(null);
        setVacations([]);
        setLabClosedDays([]);
        setErrors({});
        handleClose();
    };

    const handleDateChange = (date, setFieldValue) => {
        if (date) {
            setSelectedSlot(null);
            setLoading(true); 
            setFieldValue("trainingDate", date);
            setErrors((prevErrors) => ({ ...prevErrors, trainingDate: undefined }));

            const request = {
                lab_id,
                duration,
                sample_count,
                volunteer_count,
                start_date: date.toISOString().split("T")[0],
            };

            SampleRequestService.getPickupTimeScheduleForSelectedDate(request)
                .then((data) => {
                    setScheduledDate(date.toISOString().split("T")[0]);
                    // setScheduledTime(data.pickup_time?.map((time) => time.slice(0, 5)) || []);
                    const slots = data.quest_slots
                    ? Object.values(data.quest_slots).map(q => ({
                        displayTime: q.time,
                        slots: q.slots,
                      }))
                    : [];
            
                    setQuestSlots(slots);
                    setLoading(false); 
                })
                .catch((error) =>{setLoading(false);console.error("Error fetching pickup times for selected date:", error)});
        }
    };

    // const handleTimeClick = (time) => {
    //     setSelectedTime(time);
    //     setErrors((prevErrors) => ({ ...prevErrors, trainingTime: undefined }));
    // };
    const handleTimeClick = (slot) => {
        setSelectedSlot(slot);
        setErrors(prev => ({ ...prev, trainingTime: undefined }));
    };
      
    const handleSubmit =async (values, { setSubmitting }) => {
        // if (!selectedTime) {
        if (!selectedSlot) {
            setErrors((prevErrors) => ({ ...prevErrors, trainingTime: "Please select a pickup time." }));
            setSubmitting(false);
            return;
        }
        
        try {
            const pickupSchedule = {
                // selectedTime,
                scheduledDate,
                selectedTime: selectedSlot.displayTime, // UI
                selectedSlots: selectedSlot.slots,        // backend payload
                type,
                sampleBckpCount : volunteer_count
            };
           await onConfirm(pickupSchedule);
            if(!isModal){
                await confirmDelivery();
            }

            if(isModal){
                handleModalClose();
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setSubmitting(false);
        }
    };
    const shouldDisableDate = (date) => { 
        const formattedDate = date.toISOString().split("T")[0];
    
        // Check against vacation dates to disable them
        if (
            vacations.some((vacation) => {
                const from = new Date(vacation.from_date);
                const to = new Date(vacation.to_date);
    
                // Normalize from/to dates by removing time
                const normalizedFrom = new Date(from.getFullYear(), from.getMonth(), from.getDate());
                const normalizedTo = new Date(to.getFullYear(), to.getMonth(), to.getDate());
                const normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    
                return normalizedDate >= normalizedFrom && normalizedDate <= normalizedTo;
            })
        ) {
            return true;
        }
    
        // Check against lab closed days to disable them
        const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
        return labClosedDays.includes(dayName);
    };
    
    return (
        <>  
          {isModal && (
            <div className="el-deactivate-modal  el-schedule-pickup-sr-div">
                <Modal show={show} onHide={handleClose} dialogClassName="el-schedule-pickup-sr-modal" backdrop="static" centered>
                    {/* closeButton */}
                    <Modal.Header dialogClassName="el-modal-header" >
                        <Modal.Title> {type == 'no-preferable' ? `Next Available Pickup` : `Schedule Your Pickup`}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="el-super-admin">
                            <Formik
                                initialValues={{ trainingDate: scheduledDate, trainingTime: null }}
                                enableReinitialize={true}
                                onSubmit={handleSubmit}
                            >
                                {({ values, setFieldValue, touched }) => (
                                    <Form className=' '>
                                        <Row>
                                            <Col xl={5}>
                                                <div className='form-group p-2'>
                                                    <div className='mt-1'>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DateCalendar
                                                                minDate={new Date(startScheduledDate)} // Set the minimum selectable date
                                                                value={scheduledDate ? new Date(scheduledDate) : null}
                                                                onChange={(date) => handleDateChange(date, setFieldValue)}
                                                                shouldDisableDate={shouldDisableDate}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>

                                                    {touched.trainingDate && errors.trainingDate && (
                                                        <div className="text-danger mt-3">{errors.trainingDate}</div>
                                                    )}
                                                </div> 
                                            </Col>
                                            <Col xl={7}>
                                                <div >
                                                    <div className="mb-2 mt-3">
                                                        <span>

                                                            <span><b>
                                                                { new Date(scheduledDate).getTime() === 0 ? "No date available" :  new Date(scheduledDate).toLocaleDateString("en-US", {
                                                                    weekday: "long", // Add the day name
                                                                    year: "numeric",
                                                                    month: "long",
                                                                    day: "numeric",
                                                                })} </b></span><br />

                                                            This request requires a {duration} min block for {sample_count} {sample_count>1 ? 'samples': 'sample'}</span><br />
                                                    </div>
                                                    <span>
                                                        Select pickup time</span>
                                                    <div
                                                        className="mt-3"
                                                        style={{
                                                            height: '27vh',
                                                            overflow: 'auto',  
                                                            display:'flex', flexWrap:'wrap'
                                                            
                                                        }}
                                                    >   
                                                    {loading ? (
                                                        <>
                                                            <LoadingComponent></LoadingComponent>
                                                        </>
                                                    ): (
                                                        <>
                                                            {scheduledTime?.length > 0 ? (
                                                                (type === 'no-preferable' ? [scheduledTime[0]] : scheduledTime)?.map((time, index) => {
                                                                    const [hour, minute] = time.split(':').map(Number);
                                                                    const ampm = hour >= 12 ? 'PM' : 'AM';
                                                                    const formattedHour = hour % 12 || 12; // Convert 0 hour to 12 for 12-hour format
                                                                    const displayTime = `${formattedHour}:${minute.toString().padStart(2, '0')} ${ampm}`;
                                                                    return (
                                                                        <button
                                                                            key={index}
                                                                            onClick={() => handleTimeClick(time)}
                                                                            value={time}
                                                                            className={`el-main-button me-3 mb-3 el-datebtn ${selectedTime === time ? "el-main-active" : ""
                                                                                }`}
                                                                            variant="secondary"
                                                                            type="button"
                                                                        >
                                                                            <span>{displayTime}</span>
                                                                        </button>
                                                                    );
                                                                })
                                                            ) : (
                                                                <option value="">No times available</option>
                                                            )}
                                                        </>
                                                    )}
                                                    </div>


                                                </div>
                                                {errors.trainingTime && (
                                                    <div className="text-danger mt-3">{errors.trainingTime}</div>
                                                )}
                                            </Col>
                                            <Col md={12}>
                                            {type == 'no-preferable' ? (<div className="m-3 me-0">
                                                    <span>Along with the collection times we will do our best to fulfill this request pending donor availability.</span>
                                                </div>) : <div className="ms-3">

                                                    <p className="el-modal-content">If your desired pick-up time is unavailable, please understand the slot has been filled.<br/> Along with the collection times we will do our best to fulfill this request pending donor availability.</p>
                                                   
                                                    <p   className="el-modal-content mb-3">If this is an urgent matter, please contact help@donorxlabs.com and we'll do our best to accomodate you.</p>

                                                </div>}

</Col>
                                        </Row>



                                        <div className='m-2 d-flex align-items-center'>
                                            <button className="el-main-button me-3" variant="secondary" type="submit">
                                                <span><i className="el-icon-add-person"></i>Confirm Pickup Time</span>
                                            </button>
                                            <button className="back-link ms-3" type="button" variant="danger" onClick={handleModalClose}>Close</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
            )}

            {!isModal && (
                <div className="el-schedule-pickup-sr-div">
                        <div className="el-super-admin">
                            <Formik
                                initialValues={{ trainingDate: scheduledDate, trainingTime: null }}
                                enableReinitialize={true}
                                // onSubmit={handleSubmit}
                            >
                                {({ values, setFieldValue, touched, setSubmitting }) => (
                                    <Form className=' '>
                                        <Row>
                                            <Col xl={5}>
                                                <div className='form-group p-2'>
                                                    <div className='mt-1'>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DateCalendar
                                                                minDate={new Date(startScheduledDate)} // Set the minimum selectable date
                                                                value={scheduledDate ? new Date(scheduledDate) : null}
                                                                onChange={(date) => handleDateChange(date, setFieldValue)}
                                                                shouldDisableDate={shouldDisableDate}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>

                                                    {touched.trainingDate && errors.trainingDate && (
                                                        <div className="text-danger mt-3">{errors.trainingDate}</div>
                                                    )}
                                                </div> 
                                            </Col>
                                            <Col xl={7}>
                                                <div >
                                                    <div className="mb-2 mt-3">
                                                        <span>

                                                            <span><b>
                                                                { new Date(scheduledDate).getTime() === 0 ? "No date available" :  new Date(scheduledDate).toLocaleDateString("en-US", {
                                                                    weekday: "long", // Add the day name
                                                                    year: "numeric",
                                                                    month: "long",
                                                                    day: "numeric",
                                                                })} </b></span><br />

                                                            This request requires a {duration} min block for {sample_count} {sample_count>1 ? 'samples': 'sample'}</span><br />
                                                    </div>
                                                    <span>
                                                        Select pickup time</span>
                                                    <div
                                                        className="mt-3"
                                                        style={{
                                                            // height: '40vh',
                                                            height: '250px',
                                                            overflow: 'auto',  
                                                            display:'flex', flexWrap:'wrap'
                                                            
                                                        }}
                                                    >   
                                                    {loading ? (
                                                        <>
                                                            <LoadingComponent></LoadingComponent>
                                                        </>
                                                    ): (
                                                        <>
                                                            {/* {scheduledTime?.length > 0 ? ( */}
                                                            {questSlots?.length > 0 ? (
                                                                // (type === 'no-preferable' ? [scheduledTime[0]] : scheduledTime)?.map((time, index) => {
                                                                (type === 'no-preferable' ? [questSlots[0]] : questSlots)?.map((slot, index) => {
                                                                    // const [hour, minute] = time.split(':').map(Number);
                                                                    const [hour, minute] = slot.displayTime.split(":").map(Number);
                                                                    const ampm = hour >= 12 ? 'PM' : 'AM';
                                                                    const formattedHour = hour % 12 || 12; // Convert 0 hour to 12 for 12-hour format
                                                                    // const displayTime = `${formattedHour}:${minute.toString().padStart(2, '0')} ${ampm}`;
                                                                    return (
                                                                        <button
                                                                            key={index}
                                                                            // onClick={() => handleTimeClick(time)}
                                                                            onClick={() => handleTimeClick(slot)}
                                                                            value={slot}
                                                                            className={`el-main-button me-3 mb-3 el-datebtn ${
                                                                                selectedSlot?.displayTime === slot.displayTime ? "el-main-active" : ""
                                                                            }`}
                                                                            variant="secondary"
                                                                            type="button"
                                                                        >
                                                                            {/* <span>{displayTime}</span> */}
                                                                            <span>
                                                                                {formattedHour}:{minute.toString().padStart(2, "0")} {ampm}
                                                                            </span>
                                                                        </button>
                                                                    );
                                                                })
                                                            ) : (
                                                                <option value="">No times available</option>
                                                            )}
                                                        </>
                                                    )}
                                                    </div>


                                                </div>
                                                {errors.trainingTime && (
                                                    <div className="text-danger mt-3">{errors.trainingTime}</div>
                                                )}
                                            </Col>
                                            <Col md={12}>
                                            {type == 'no-preferable' ? (<div className="m-3 me-0">
                                                    <span>Along with the collection times we will do our best to fulfill this request pending donor availability.</span>
                                                </div>) : <div className="ms-3">

                                                    <p className="el-modal-content">If your desired pick-up time is unavailable, please understand the slot has been filled.<br/> Along with the collection times we will do our best to fulfill this request pending donor availability.</p>
                                                   
                                                    <p   className="el-modal-content mb-3">If this is an urgent matter, please contact help@donorxlabs.com and we'll do our best to accomodate you.</p>

                                                </div>}

                                        </Col>
                                        </Row>



                                        <div className='m-2 d-flex align-items-center'>
                                            <button className="el-main-button me-3" variant="secondary" type="button" onClick={()=>{
                                                handleSubmit(values, {setSubmitting});
                                            }}>
                                                <span><i className="el-icon-add-person"></i>Confirm Pickup Time</span>
                                            </button>
                                            {/* <button className="back-link ms-3" type="button" variant="danger" onClick={handleModalClose}>Close</button> */}
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                </div>
            )}
        </>
    );
}

export default SchedulePickupSampleRequestModal